const PersonaFitRoleAntagonists = {
    'wil-1aanpa': 'zij-1aanpa',
    'wil-2contr': 'zij-2contr',
    'wil-3innov': 'zij-3innov',
    'wil-4exper': 'zij-4exper',
    'wil-5coord': 'zij-5coord',
    'wil-6inspi': 'zij-6inspi',
    'wil-7verbi': 'zij-7verbi',
    'wil-8onder': 'zij-8onder',
    'zij-1aanpa': 'wil-1aanpa',
    'zij-2contr': 'wil-2contr',
    'zij-3innov': 'wil-3innov',
    'zij-4exper': 'wil-4exper',
    'zij-5coord': 'wil-5coord',
    'zij-6inspi': 'wil-6inspi',
    'zij-7verbi': 'wil-7verbi',
    'zij-8onder': 'wil-8onder'
};

export default PersonaFitRoleAntagonists;
